'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    getThumbnailUrl = require('../utils/getThumbnailUrl'),
    DragItemTypes = require('../constants/DragItemTypes'),
    ImageSizes = require('../constants/ImageSizes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    createFlexibleImageQueueMixin = require('../mixins/createFlexibleImageQueueMixin'),
    guid = require('simple-guid'),
    assign = require('react/lib/Object.assign'),
    { DragDropMixin, ImagePreloaderMixin, DropEffects } = require('react-dnd'),
    { PropTypes } = React;

require('./GrabbagItem.less');

function isSmallImage(image) {
  var size = image.size;
  return size.width < 1024 && size.height < 1024;
}

var GrabbagItem = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, DragDropMixin, ImagePreloaderMixin, createFlexibleImageQueueMixin(1)],

  className: 'editor-GrabbagItem',

  propTypes: {
    item: PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      progress: PropTypes.number,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired
      }),
    }).isRequired,
    isUsed: PropTypes.bool.isRequired,
    onDeleteClick: PropTypes.func.isRequired
  },

  getCSSModifiers() {
    var { isUsed } = this.props;

    return [
      isUsed && 'used'
    ];
  },

  getImageOptions() {
    var { image } = this.props.item;
    if (!image) {
      return;
    }

    return {
      image: image,
      mode: 'preview',
      sizes: {
        thumb: true,
        normal: true,
        retina: window.devicePixelRatio > 1.5
      }
    };
  },

  getImageUrlsToPreload() {
    return [this.getDragPreviewUrl()];
  },

  getDragPreviewUrl() {
    if (!this.props.item.image) {
      return;
    }

    var image = this.props.item.image,
        scale = this.getDragImageScale();

    return getThumbnailUrl(image, {
      mode: 'preview',
      width: Math.round(ImageSizes.EDITOR_GRABBAG_ITEM_DRAG.width * scale),
      height: Math.round(ImageSizes.EDITOR_GRABBAG_ITEM_DRAG.height * scale)
    });
  },

  configureDragDrop(registerType) {
    registerType(DragItemTypes.IMAGE, {
      dragSource: {
        canDrag() {
          return this.hasPreloadedImage(this.getDragPreviewUrl());
        },

        beginDrag() {
          return {
            effectsAllowed: [DropEffects.COPY],
            dragPreview: this.getPreloadedImage(this.getDragPreviewUrl()),
            item: {
              image: assign({}, this.props.item.image, {
                uuid: guid(),
                caption: ''
              })
            }
          };
        }
      }
    });
  },

  componentDidUpdate(prevProps) {
    if (prevProps.item.image !== this.props.item.image) {
      this.updateImageQueue();
    }
  },

  render() {
    var image = this.props.item.image,
        isLoading = !image,
        progress = this.props.item.progress;

    return (
      <div {...this.dragSourceFor(DragItemTypes.IMAGE)}
           className={this.getClassName()}
           style={{
             backgroundImage: this.getBackgroundImageUrl()
           }}>

        {this.renderLoaderImg()}

        {isLoading &&
          <div className='editor-GrabbagItem-progress'>
            <div className='editor-GrabbagItem-progressBar'
                 style={{
                   width: Math.min(Math.max(2, progress * 100), 96) + '%'
                 }} />
          </div>
        }

        {image && isSmallImage(image) &&
          <div className='editor-GrabbagItem-small'>
            <div className='editor-GrabbagItem-smallExclamation'>!</div>
            <div className='editor-GrabbagItem-smallDetails'>
              <span className='editor-GrabbagItem-smallHeader'>Small Image</span>
              <span className='editor-GrabbagItem-smallInfo'>Images that are at least <b>1024px</b> will work best.</span>
            </div>
          </div>
        }

        <div className='editor-GrabbagItem-item' />

        <Button size='xsmall'
                round
                color='black'
                overlay
                className='editor-GrabbagItem-delete'
                onClick={this.props.onDeleteClick}>
          <Icon name='cross'
                size='xxsmall'
                mode='stroke' />
        </Button>
      </div>
    );
  }
});

module.exports = GrabbagItem;



/** WEBPACK FOOTER **
 ** ./editor/GrabbagItem.jsx
 **/